import { FetchContext } from '../fetch-context';
import { MasterAward } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getMasterAwards: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<MasterAward[]> = (fetchContext, accessToken) => fetch(`${fetchContext.baseUrl}/api/admin/master-awards`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<MasterAward[]>(fetchContext.errorStore, response, 'get master awards'));
